import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { EFetchStatus } from "./types";

export const fetchLocales = createAsyncThunk("locales/fetchLocales", async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(import.meta.env.REACT_APP_API_ENDPOINT + "/locales");
        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export interface ILocale {
    name: string;
    code: string;
}

export interface ILocaleState {
    locales: ILocale[];
    status: EFetchStatus;
}

const initialState: ILocaleState = {
    locales: [],
    status: EFetchStatus.IDLE,
};

const localesSlice = createSlice({
    name: "locales",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLocales.pending, (state) => {
            state.status = EFetchStatus.PENDING;
        });
        builder.addCase(fetchLocales.fulfilled, (state, action) => {
            state.locales = action.payload;
            state.status = EFetchStatus.FULFILLED;
        });
        builder.addCase(fetchLocales.rejected, (state) => {
            state.status = EFetchStatus.REJECTED;
        });
    },
});

export default localesSlice.reducer;
